"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const transhipment_types_1 = require("./transhipment.types");
const initialState = {
    dataGrid: [],
    errorCode: 0,
    isError: false,
    errorMessage: '',
    isLoading: false,
    isSuccess: false,
    dataGridHistory: [],
    mutationMode: false,
    isLoadingUpload: false,
    isLoadingDownload: false,
    lastUpdated: new Date(),
    selectedYear: new Date().getFullYear().toString(),
    dataItem: {
        id: '',
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        year: '',
        type: '',
        brand_id: '',
        brand_name: '',
        created_by: '',
        modified_by: '',
        created_date: new Date(),
        modified_date: new Date(),
    },
    dataItemHistory: {
        id: '',
        year: '',
        status: '',
        filename: '',
        filepath: '',
        log_message: '',
        uploaded_by: '',
        uploaded_at: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'type', dir: 'asc' },
            { field: 'brand_name', dir: 'asc' }
        ]
    },
    dataStatesHistory: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'uploaded_at', dir: 'desc' }]
    },
};
const planningTranshipmentReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [transhipment_types_1.planningTranshipmentTypes.SET_DATA_GRID_TRANSHIPMENT]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        const { count, dataGridHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, dataGridHistory, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: count }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.SET_LAST_SUCCEED_UPLOAD]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, lastUpdated: action.payload.lastUpdated });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, dataItemHistory, mutationMode, isSuccess, selectedYear, isLoadingUpload, isLoadingDownload } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, selectedYear: selectedYear ? selectedYear : initialState.selectedYear, dataItemHistory: dataItemHistory ? dataItemHistory : initialState.dataItemHistory, isLoadingUpload: isLoadingUpload ? isLoadingUpload : initialState.isLoadingUpload, isLoadingDownload: isLoadingDownload ? isLoadingDownload : initialState.isLoadingDownload });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isSuccess: false, isLoading: false, isLoadingUpload: false, isLoadingDownload: false });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        const { dataStatesHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesHistory, isLoading: true });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_FILTER_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, filter: action.payload }) });
    },
    [transhipment_types_1.planningTranshipmentTypes.ON_SORT_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, sort: action.payload }) });
    }
});
exports.default = planningTranshipmentReducer;
